import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'BIRTH_CERT_RF'
  }
  getTypeName () {
    return 'Свидетельство о рождении РФ'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(),
      {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        sex: individual.sex,
        birthday: individual.birthday
      })
  }
  updateSteps (scheme) {
    const formatSerNum = (v) => {
      let ms = /^([IVX]{2,})[\s-]*([А-ЯЁ]{2,2})[\s-№#]*(\d{6})$/.exec(v.toUpperCase())
      v = ms ? `${ms[1]} ${ms[2]} ${ms[3]}` : v
      return v
    }
    const ruleSerNum = (v) => !v || /^[IVX]{2,}\s*[А-ЯЁ]{2,2}\s*\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [II БЮ 123456]'
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'
    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-select',
            label: 'Пол',
            name: 'sex',
            itemText: 'text',
            itemValue: 'value',
            items: [
              {value: 'F', text: 'Жен.'},
              {value: 'M', text: 'Муж.'}
            ],
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplace',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Номер записи акта о рождении',
            name: 'birthNumber',
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Серия номер',
            name: 'sernum',
            format: formatSerNum,
            rules: Array.of(ruleSerNum),
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата выдачи',
            name: 'issued',
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Организация выдавшая документ',
            name: 'issuer',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия отца',
            name: 'fatherSurname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя отца',
            name: 'fatherFirstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество отца',
            rules: Array.of(ruleNameRu),
            name: 'fatherPatronymic',
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Гражданство отца',
            name: 'fatherCitizenship',
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия матери',
            name: 'motherSurname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя матери',
            name: 'motherFirstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество матери',
            name: 'motherPatronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Гражданство матери',
            name: 'motherCitizenship',
            grow: true,
            size: {sm6: true, xs8: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return `${model['sernum'] ? model['sernum'] : '-'}`
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    return formats.createComp(`
      <div>
      <div>Номер:<b> ${model['sernum'] ? model['sernum'] : '-'}</b></div>
      <div>Дата выдачи:<b> ${model['issued'] ? formats.formatDate(model['issued']) : '-'}</b></div>
      </div>`)
  }
}

class Model {
  constructor () {
    this.modelType = '03.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocBirthCertRF.js